module.exports = __webpack_public_path__ + "img/ic_food_function_take_out_img.3f05ffd1.png";